import "./styles.scoped.css";
export default {
    "breadcrumb-group": "awsui_breadcrumb-group_d19fg_zzbk1_93",
    "item": "awsui_item_d19fg_zzbk1_105",
    "breadcrumb-group-list": "awsui_breadcrumb-group-list_d19fg_zzbk1_116",
    "ellipsis": "awsui_ellipsis_d19fg_zzbk1_126",
    "icon": "awsui_icon_d19fg_zzbk1_134",
    "mobile": "awsui_mobile_d19fg_zzbk1_138"
};
